import React from 'react';
import { useParams } from 'react-router-dom';
import { LoadingSpinner } from '../../../../Components/Molecules/LoadingUI';
import EventsDetails from '../EventsDetail';
import EventImageVideoGallery from '../EventImageVideoGallery';
import useDataEventDetails from '../EventsDetail/data';

const EventsDetailsRoute = () => {
    const { eventId } = useParams();
    const { event, isLoading } = useDataEventDetails(eventId);

    const endDate = new Date(event?.endDate);
    const currentDate = new Date();
    if (currentDate <= endDate) {
        return <EventsDetails event={event} isLoading={isLoading} />;
    } else {
        return <EventImageVideoGallery />;
    }
};

export default EventsDetailsRoute;
